export default function(name) {
  return {
    agent: { th: "เอเย่นต์" },
    "sub-agent": { th: "ซับเอเย่นต์" },
    "sub-direct": { th: "ซับเอเยนต์" },
    retail: { th: "ร้านปลีก" },
  }[name]?.th;
}
